module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-CigaretteBreakOnTheWater-Web-640.50489885.jpg";